import { render, staticRenderFns } from "./dr-text-area.vue?vue&type=template&id=6cc4ae08&"
import script from "./dr-text-area.vue?vue&type=script&lang=js&"
export * from "./dr-text-area.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports